import React from "react";
import { Switch as ChakraSwitch, SwitchProps } from "@chakra-ui/react";

const Switch = ({ ...props }: SwitchProps) => {
  return <ChakraSwitch {...props}>{props.children}</ChakraSwitch>;
};

export default Switch;
